/*=========================================================================================
  File Name: moduleBrandActions.js
  Description: Brand Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from '@/plugins/axios';

export default {
  SoftDelete({}, payload) {
    return new Promise((resolve, reject) => {
      let url = '';
      switch (payload.feature) {
        case 'user':
          url = 'users';
          break;
        case 'product':
          url = 'products';
          break;
        case 'warehouse':
          url = 'ware-houses';
          break;
        case 'purchase-order':
          url = 'purchases-orders';
          break;
        case 'purchases':
          url = 'purchases';
          break;
        case 'purchase-return':
          url = 'purchase-return';
          break;
        case 'supplier':
          url = 'supplier';
          break;
        case 'customer':
          url = 'customers';
          break;
        case 'role':
          url = 'roles';
          break;
        case 'expense-categories':
          url = 'expense-categories';
          break;
        case 'income-categories':
          url = 'income-categories';
          break;
        case 'category':
          url = 'categories';
          break;
        case 'brand':
          url = 'brands';
          break;
        case 'shop':
          url = 'shops';
          break;
        case 'service':
          url = 'services';
          break;
        case 'document-uploads':
          url = 'document-uploads';
          break;
        case 'event-type':
          url = 'event-type';
          break;
        case 'expensesetting':
          url = 'settings/expense-settings';
          break;
        default:
          break;
      }
      axios
        .get(`${url}/${payload.id}/soft-delete`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  getModuleUrl: (feature) => {
    let url = '';
    switch (feature) {
      case 'user':
        url = 'users';
        break;
      case 'product':
        url = 'products';
        break;
      case 'purchase-order':
        url = 'purchases-orders';
        break;
      case 'purchases':
        url = 'purchases';
        break;
      case 'purchase-return':
        url = 'purchase-return';
        break;
      case 'supplier':
        url = 'supplier';
      case 'document-uploads':
        url = 'document-uploads';
        break;
      default:
        break;
    }
  },

  async notifications({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`notifications`)
        .then((resp) => {
          if (resp != '' || resp != null) {
            commit('SET_NOTIFICATION', resp.data.data);
            resolve(resp.data.data);
          } else {
            reject('Get notifications Not Found');
          }
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

  async RemoveNotification({}, Credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post(`notifications/${Credentials}/remove`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
  async ReadNotification({}, Credentials) {
    return new Promise((resolve, reject) => {
      axios
        .post(`notifications/${Credentials}/read`)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },
};
